import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss']
})
export class PageTitleComponent implements OnInit {
  title: string = '';
  desc: string = '';

  constructor(
    public router: Router
  ) { }

  ngOnInit(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updateHeader(this.router.url);
    });

    this.updateHeader(this.router.url);
  }

  private updateHeader(url: string): void {
    const path = url.replace(/^\//, '');

    if (path.includes('dashboard/settlement')) {
      this.title = 'Settlement';
      this.desc = 'Reconciliation and Settlement';
    } else if (path.includes('dashboard/customers')) {
      this.title = 'Customers';
      this.desc = 'Manage Customer Information';
    } else if (path.includes('dashboard/manage-accounts')) {
      this.title = 'Manage Accounts';
      this.desc = 'Manage Accounts';
    } else if (path.includes('dashboard/manage-cards')) {
      this.title = 'Manage Cards';
      this.desc = 'Manage Card Operations';
    } else if (path.includes('dashboard/kyc')) {
      this.title = 'KYC';
      this.desc = 'Customer Compliance Management';
    } else if (path.includes('dashboard/country-limits')) {
      this.title = 'Country Limits';
      this.desc = 'Manage Country Limits';
    } else if (path.includes('dashboard/exchange-rates')) {
      this.title = 'Exchange Rates';
      this.desc = 'Manage Exchange Rates';
    } else if (path.includes('dashboard/organisation')) {
      this.title = 'Organisation';
      this.desc = 'Manage Organization';
    } else if (path.includes('dashboard/fees')) {
      this.title = 'Fees';
      this.desc = 'Manage Fee Structures';
    } else if (path.includes('dashboard/charged-fees')) {
      this.title = 'Charged Fees';
      this.desc = 'Manage Charged Fees';
    } else if (path.includes('dashboard/issuers')) {
      this.title = 'Issuers';
      this.desc = 'Manage Issuers';
    } else if (path.includes('dashboard/fwp')) {
      this.title = 'FWP';
      this.desc = 'Financial Wellness Package';
    } else if (path.includes('dashboard/activity-log')) {
      this.title = 'Activity Log';
      this.desc = 'Activity Log';
    } else if (path.includes('dashboard/settings')) {
      this.title = 'Settings';
      this.desc = 'Application Settings';
    } else if (path.includes('dashboard/aml')) {
      this.title = 'AML';
      this.desc = 'Anti-Money Laundering compliance';
    } else if (path.includes('dashboard/issuer-users')) {
      this.title = 'Issuer Users';
      this.desc = 'Manage Issuer Accounts';
    } else if (path.includes('dashboard/transaction-monitoring')) {
      this.title = 'Transaction Monitoring';
      this.desc = 'Transaction Monitoring';
    } else {
      this.title = 'Dashboard';
      this.desc = 'Here’s a summary of your portal';
    }
  }
}
